<template>
  <div id="SliderComponent">
    <div
      v-if="!disabledNavagation"
      class="w-auto absolute left-0 z-50 top-50 xl:relative"
    >
      <i
        @click="slider.goToPrev()"
        class="material-icons font-bold cursor-pointer text-3xl text-dark"
        >keyboard_arrow_left</i
      >
    </div>
    <div :class="` ${disabledNavagation ? ' w-full ' : ' w-11/12 '} `">
      <no-ssr placeholder="Loading...">
        <vue-agile ref="carousel" :options="{ ...options, navButtons: false }">
          <slot />
        </vue-agile>
      </no-ssr>
    </div>
    <div
      v-if="!disabledNavagation"
      class="w-auto absolute right-0 z-50 top-50 xl:relative"
    >
      <i
        @click="slider.goToNext()"
        class="material-icons text-3xl font-bold cursor-pointer text-dark"
        >keyboard_arrow_right</i
      >
    </div>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile';
import ENV from '@/assets/js/ENV.config.js';

export default {
  name: 'SliderComponent',
  components: {
    VueAgile,
  },
  props: {
    options: {
      type: Object,
      default: () => ENV.slider.sliderConfig,
    },
    disabledNavagation: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => {
    return {};
  },
  computed: {
    slider() {
      return this.$refs.carousel;
    },
  },
};
</script>

<style>
.thumbnails {
  margin: 0 -5px;
  width: calc(100% + 10px);
}
.agile__nav-button {
  position: absolute;
  top: 0%;
  color: white;
  font-size: 30px;
  font-weight: 900;
  height: 100%;
}
.agile__nav-button--next {
  right: 0px;
}
.absolute {
  position: absolute;
}
.left-0 {
  left: 0;
}
.right-0 {
  right: 0;
}
.top-50 {
  top: 50%;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
